import React, { useState, useEffect } from "react";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Open first FAQ by default

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  // Add CSS for FAQ accordion if not present globally
  useEffect(() => {
    // Ensure styles are applied (they may already be in global CSS)
    const style = document.createElement("style");
    style.textContent = `
      .faq-grid {
        max-width: 850px;
        margin: 0 auto;
      }
      .faq-item {
        background: white;
        border-radius: 24px;
        margin-bottom: 18px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.03);
        border: 1px solid #e2e8f0;
        overflow: hidden;
        transition: all 0.2s;
      }
      .faq-question {
        padding: 20px 28px;
        font-weight: 700;
        font-size: 1.1rem;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: white;
        transition: 0.2s;
      }
      .faq-question i {
        color: #1e40af;
        transition: transform 0.3s ease;
      }
      .faq-item.active .faq-question i {
        transform: rotate(180deg);
      }
      .faq-answer {
        padding: 0 28px 20px 28px;
        color: #475569;
        line-height: 1.5;
        display: none;
        border-top: 1px solid #eef2ff;
      }
      .faq-item.active .faq-answer {
        display: block;
      }
    `;
    if (!document.querySelector("#faq-styles")) {
      style.id = "faq-styles";
      document.head.appendChild(style);
    }
  }, []);

  const faqData = [
    {
      question: "How do I create an account on FORMAX PAY?",
      answer:
        "Simply click on 'Sign In' and register using your mobile number and email. OTP verification completes your account creation in seconds.",
    },
    {
      question: "How can I add money to my account?",
      answer:
        "After logging in, go to the 'Add Funds' section and choose your preferred payment method (UPI, Debit/Credit Card, Netbanking). The amount reflects instantly.",
    },
    {
      question: "Do you offer cashback or discounts?",
      answer:
        "Yes! We provide instant commission and upfront discounts on every recharge and bill payment. The savings are applied directly at checkout.",
    },
    {
      question: "Is FORMAX PAY safe for recharges?",
      answer:
        "Absolutely. FORMAX IT SOLUTIONS PRIVATE LIMITED follows strict security protocols and encryption. Your data and payments are fully protected.",
    },
    {
      question: "How can I contact support?",
      answer:
        "You can email us at support@formaxpay.in or call +91 7890090500. Our support team is available Mon-Sat, 9 AM to 8 PM.",
    },
    {
      question: "What services can I recharge?",
      answer:
        "Mobile Recharge, DTH Recharge, Google Play Recharge and Utility Bills are available for instant recharge and payment. ",
    },
  ];

  return (
    <section id="faq" style={{ padding: "60px 0", background: "#ffffff" }}>
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <p className="section-sub">Got questions? We have answers.</p>
        <div className="faq-grid">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
            >
              <div className="faq-question" onClick={() => toggleFaq(index)}>
                {item.question}
                <i className="fas fa-chevron-down"></i>
              </div>
              <div className="faq-answer">{item.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
